module.exports = __webpack_public_path__ + "static/favicon-166ff2d5c5e9103192ed4385a9a38f9c.ico";